'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { ReviewPopupViewDS } from '@src/components/blocks/review-popup-ds/review-popup-view-ds'
import plReviewPhotoPopupStateManager, {
  PLReviewPopupState,
} from '@src/quince-site-common/src/redux/globalStateManager/PLReviewPhotoPopupStateManager'
import { useAppSelector } from '@src/quince-site-common/src/redux/hooks'

// @i18n-ignore
const REVIEW_DS_WIDGET_TEST_ID = 'pl-review-popup-ds'

// PL wiring for the shared DS photo popup view: reads the PL-scoped state manager (which adds
// pagination) and forwards its fetch-more trigger. Responsive — replaces both device popups on
// the DS branch.
export function PLReviewPopupDS() {
  const pathname = usePathname()
  const { showPopUp, productReviews, reviewId, imageIndex, hasMore } = useAppSelector<PLReviewPopupState>(
    plReviewPhotoPopupStateManager,
    plReviewPhotoPopupStateManager.getReviewPopupState,
  )

  useEffect(() => {
    plReviewPhotoPopupStateManager.hideReviewPopUp()
  }, [pathname])

  return (
    <ReviewPopupViewDS
      showPopUp={showPopUp}
      productReviews={productReviews}
      reviewId={reviewId}
      imageIndex={imageIndex}
      onClose={plReviewPhotoPopupStateManager.hideReviewPopUp}
      testId={REVIEW_DS_WIDGET_TEST_ID}
      hasMore={hasMore}
      onNearEnd={plReviewPhotoPopupStateManager.triggerFetchMore}
    />
  )
}

export default PLReviewPopupDS
